/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsBio_seller = {
    readonly serviceId: string | null;
    readonly isRewardsTier2: boolean | null;
    readonly liveStorefrontProfile: {
        readonly aboutUsUnbranded: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller">;
    readonly " $refType": "PdpSharedDealerDetailsBio_seller";
};
export type PdpSharedDealerDetailsBio_seller$data = PdpSharedDealerDetailsBio_seller;
export type PdpSharedDealerDetailsBio_seller$key = {
    readonly " $data"?: PdpSharedDealerDetailsBio_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsBio_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsBio_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "isRewardsTier2",
      "name": "isAnchorListMember",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "liveStorefrontProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "aboutUsUnbranded",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsBioModalLazy_seller",
      "args": null
    }
  ]
};
(node as any).hash = '2201d83255054faff16ed69e5ec94493';
export default node;
